

import React from 'react';
import moment from 'moment';
import { 
    BarChart, 
    Bar, 
    CartesianGrid, 
    Legend,
    Tooltip,
    XAxis, 
    YAxis,
    ResponsiveContainer,
    ReferenceLine
} from 'recharts';

const Chart = (props) => {
    return (
        <div className={`${props.className}`}>
            <h5>{props.title}</h5>
            <br/>
            <ChartComponent
                type={props.type}
                xAxisType={'date'}
                staticLines={props.staticLines}
                startDate={props.startDate}
                endDate={props.endDate}
                data={props.data}
                loading={props.loading}
            />
        </div>
    );
};


const ChartComponent = (props) => {
    const { type, className, data, xAxisType, loading } = props;
    let xAxis, formmattedData;
    if (xAxisType === 'date') {
        formmattedData = data.reduce((r,i) => {
            r.push({
                ...i,
                date:moment(i.date).valueOf()
            })
            return r
        },[])

        let startDate = moment(data[0].date);
        let endDate = moment(data[data.length-1].date);

        let duration = moment.duration(endDate.diff(startDate));
        let diffDays = duration.asDays();

        let num = 4;
        let current = startDate,
          velocity = Math.round(diffDays / num);
        const ticks = [startDate.valueOf()];
      
        for (let i = 1; i < num; i++) {
          ticks.push(moment(current).add(i*velocity,'days').valueOf());
        }
        
        ticks.push(endDate.valueOf());

        xAxis = <XAxis 
            hasTick
            ticks={ticks}
            dataKey="date"
            scale="date"
            scale="band"
            tickFormatter={v => moment(v).format("D MMM YYYY")}
            />
    } else {
        xAxis = <XAxis/>
    }

    let  reference1,reference2;
    if (props.staticLines.length > 0) {
        reference1 = (
            <ReferenceLine 
                y={props.staticLines[0].value} 
                stroke="green" 
                strokeDasharray="3 3" 
                isFront={true}
                label="Free Quota (50 Request / day)"
            />
        )
        reference2 = (
            <ReferenceLine 
                y={props.staticLines[1].value} 
                stroke="red" 
                strokeDasharray="3 3" 
                isFront={true}
                label="Free Quota (1000 Request / day)"
            />
        )
    }

    if (loading) {
        return (
            <div className={`${className} card text-center`}>
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <div className={`card`}>
            <ResponsiveContainer width="95%" height={320}>
                <BarChart height={320} width="100%" data={formmattedData}>
                    <CartesianGrid vertical={false} />
                    { xAxis }
                    <YAxis hasTick/>
                    <Legend/>
                    
                    <Tooltip 
                        labelFormatter={(v) => moment(v).format("D MMM YYYY")}
                    />
                    <Bar dataKey="quantity" fill="#772DC9" barSize={30} />
                    { reference1 }
                    { reference2 }
                    
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}


export default Chart;